<template>
  <div>
    <v-card-text class="px-0 py-0">
      <div v-if="loadingEncuesta">
        <v-row>
          <v-col
            key="sl_inicioadminEncuesta_infoEncuesta"
            cols="12"
          >
            <v-skeleton-loader type="image" />
          </v-col>
        </v-row>
        <br>
        <v-row>
          <v-col
            key="sl_inicioadminEncuesta_seccionesEncuesta"
            cols="12"
          >
            <v-skeleton-loader type="image" height="500" />
          </v-col>
        </v-row>
      </div>
      <div v-else-if="valido && !loadingEncuesta && error == ''" style="position: relative;">
        <info-encuesta :obj-encuesta="objEncuesta" ></info-encuesta>
        <br>
        <secciones-encuesta :id-encuesta="idEncuesta" :token="token"></secciones-encuesta>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              dark 
              color="green darken-2" 
              fixed 
              right 
              bottom 
              v-bind="attrs"
              v-on="on"
              style="bottom:150px; z-index: 1001; background-color:#b5a36a!important ;"
              @click="goVistaPreviaEncuesta"
            >
              <v-icon dark class="mr-1">mdi-eye</v-icon> Vista previa
            </v-btn>
          </template>
          <span>Vista previa de la encuesta</span>
        </v-tooltip>
      </div>
      <v-alert 
          v-else
          type="error">
          {{error}}
      </v-alert>
    </v-card-text>

    <v-snackbar
        key="snackbar_inicioadministrarencuesta"
        v-model="snackbarError"
        :bottom="true"
        :multi-line="true"
        color="error"
    >
      {{ textoError }}
      <v-btn 
        dark 
        text 
        @click="snackbarError = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import{ getEncuestaValidate } from "@/api";

export default {
  name: "InicioDisenarEncuesta",
  components: {
    InfoEncuesta: () =>
      import("../disenarEncuesta/InfoEncuesta"),
    SeccionesEncuesta: () =>
      import("../disenarEncuesta/SeccionesEncuesta"),
  },
  props: {
    idServicio: {
      type: Number,
      required: false,
      default: ''
    },
    idEncuesta: {
      type: Number,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
    
  },
  data () {
    return {
      valido: false,
      loadingEncuesta: true,      

      objEncuesta: {},

      snackbarError: false,
      textoError: "",
      error: ""
    };
  },
  computed: {
  },
  beforeMount () {},
  async mounted () {
    this.obtenerEncuesta();
  },
  methods: {
    async obtenerEncuesta () {

      var self = this;
      self.loadingEncuesta = true;
      self.loadingSecciones = true;
      self.valido = false;
      self.objEncuesta = {};

      self.snackbarError = false;
      self.textoError = "";

      try {
        let response = await getEncuestaValidate(self.idServicio, self.idEncuesta, self.token);

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              self.objEncuesta = response.data.data;
              self.valido = true;
              self.loadingEncuesta = false;
            }
          } else {
            self.error = response.data.message;
            self.snackbarTexto = "InicioAdministrarEncuesta: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loadingEncuesta = false;
          }
        } else {
          self.error = "Error de red";
          self.snackbarTexto = "InicioAdministrarEncuesta: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loadingEncuesta = false;
        }
      } catch (e) {
        self.loadingEncuesta = false;
        self.error = e;
        self.snackbarTexto = "InicioAdministrarEncuesta: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
    goVistaPreviaEncuesta() {

      let routeData = this.$router.resolve({name: 'encuestaVistaPrevia'});
      window.open(routeData.href, '_blank');

     /*  this.$router.push({
        path: `/EncuestaVistaPrevia/${this.idEncuesta}/${this.token}`,         
      }); */
    },
  }
};
</script>